/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type TourEditDrawerGenerateAIMarkersMutationVariables = {
    tourId: string;
};
export type TourEditDrawerGenerateAIMarkersMutationResponse = {
    readonly tourGenerateAIMarkers: {
        readonly tour: {
            readonly id: string;
            readonly markers: ReadonlyArray<{
                readonly id: string;
                readonly name: string;
                readonly description: string;
                readonly scrollPosition: number;
                readonly frameIndex: number;
            }>;
        };
    };
};
export type TourEditDrawerGenerateAIMarkersMutation = {
    readonly response: TourEditDrawerGenerateAIMarkersMutationResponse;
    readonly variables: TourEditDrawerGenerateAIMarkersMutationVariables;
};



/*
mutation TourEditDrawerGenerateAIMarkersMutation(
  $tourId: String!
) {
  tourGenerateAIMarkers(input: {tourId: $tourId}) {
    tour {
      id
      markers {
        id
        name
        description
        scrollPosition
        frameIndex
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tourId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "tourId",
            "variableName": "tourId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "TourGenerateAIMarkersPayload",
    "kind": "LinkedField",
    "name": "tourGenerateAIMarkers",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Tour",
        "kind": "LinkedField",
        "name": "tour",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Marker",
            "kind": "LinkedField",
            "name": "markers",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "scrollPosition",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "frameIndex",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TourEditDrawerGenerateAIMarkersMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TourEditDrawerGenerateAIMarkersMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "3c62448480e0f6da31a72da85a7b8180",
    "id": null,
    "metadata": {},
    "name": "TourEditDrawerGenerateAIMarkersMutation",
    "operationKind": "mutation",
    "text": "mutation TourEditDrawerGenerateAIMarkersMutation(\n  $tourId: String!\n) {\n  tourGenerateAIMarkers(input: {tourId: $tourId}) {\n    tour {\n      id\n      markers {\n        id\n        name\n        description\n        scrollPosition\n        frameIndex\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '8ff9ef57cb0aff05ddfb49a000939c9a';
export default node;
